import React from 'react';
import './Home.css'; // Assuming you have a CSS file for styling
import avatar from '../assets/images/avatar.png'; // Update the path to your avatar image
import { FaInstagram, FaGithub, FaLinkedin } from 'react-icons/fa';
import pingfence from '../assets/images/Pingfence_White_Logo.png'; // Update the path to your pingfence image
import { SiKaggle } from 'react-icons/si';
import linodeLogo from '../assets/images/linode.png';
import googlelogo from '../assets/images/google.png'; // Update the path to your Google logo image
import oraclelogo from '../assets/images/oracle.png'; // Update the path to your Oracle logo image
import work1 from '../assets/images/work1.png'; // Update the path to your work image
import work2 from '../assets/images/work2.png'; // Update the path to your work image
import work3 from '../assets/images/work3.png'; // Update the path to your work image
import badge2 from '../assets/images/certs/2.png'; // Update the path to your badge image
import badge4 from '../assets/images/certs/4.png'; // Update the path to your badge image
import badge5 from '../assets/images/certs/5.png'; // Update the path to your badge image
import badge6 from '../assets/images/certs/6.png'; // Update the path to your badge image     
import badge7 from '../assets/images/certs/7.png'; // Update the path to your badge image
import badge8 from '../assets/images/certs/8.png'; // Update the path to your badge image
import badge9 from '../assets/images/certs/9.png'; // Update the path to your badge image
import badge10 from '../assets/images/certs/10.png'; // Update the path to your badge image
import badge11 from '../assets/images/certs/11.png'; // Update the path to your badge image
import badge12 from '../assets/images/certs/12.png'; // Update the path to your badge image
import badge13 from '../assets/images/certs/13.png'; // Update the path to your badge image
import badge14 from '../assets/images/certs/14.png'; // Update the path to your badge image
import badge15 from '../assets/images/certs/15.png'; // Update the path to your badge image
import badge16 from '../assets/images/certs/16.png'; // Update the path to your badge image
import badge17 from '../assets/images/certs/17.png'; // Update the path to your badge image
import badge18 from '../assets/images/certs/18.png'; // Update the path to your badge image
import dawnofdedsec from '../assets/images/dawnofdedsec.png'; // Update the path to your Dawn of DedSec image
import joindedsec from '../assets/images/joindedsec.png'; // Update the path to your Join DedSec image
import dedsecteam from '../assets/images/dedsecteam.png'; // Update the path to your DedSec team image
import pingfencebanner from '../assets/images/pingfencebanner.png'; // Update the path to your Pingfence banner image
import gitstats2 from '../assets/images/gitstats2.png'; // Update the path to your GitHub stats image
import gitstats3 from '../assets/images/gitstats3.png'; // Update the path to your GitHub stats image
import gitstats4 from '../assets/images/gitstats4.png'; // Update the path to your GitHub stats image
import gitstats5 from '../assets/images/gitstats5.png'; // Update the path to your GitHub stats images
import mycontribution from '../assets/images/mycontribution.png'; // Update the path to your contribution image
import { Helmet } from 'react-helmet';





function Home() {
  return <div className='home-container'>
    <Helmet>
      <title>Aadhaar Koul | Home Page</title>
    </Helmet>
    <div className='discount'>
      <a href="/shop"><p>Get upto 75% off on my online Store →</p></a>
    </div>
    <div className='items1'>
      <div className='items1-left'>
        <div className='bigtitle'>AADHAAR KOUL</div>
        <div className='owners-designation'>CS Engineer and Hacker</div>
        <div className='about-avatar'><h4>Recent B.Tech graduate in Computer Science, eager to apply my skills
          in a wide range of tech roles. My experience spans data analysis, software
            development and innovative projects. I'm driven by a passion for learning
            and problem-solving, ready to take on new challenges and contribute to 
            dynamic teams. Open to opportunities across the tech landscape</h4>
        </div>
        
      </div>
      <div className='items1-right'>
        <div className='avatar'>
          <img src={avatar} alt="Avatar" />
        </div>
      </div>
    </div>



    <div className='items2'>
      <div className="socials">
          <a href="https://instagram.com/aadhaarkoul" ><FaInstagram /></a>
          <a href="https://github.com/aadhaar-debug" ><FaGithub /></a>
          <a href="https://www.linkedin.com/in/aadhaar-koul-7271b6204/" ><FaLinkedin /></a>
          <a href="https://kaggle.com/aadhaarkoul" ><SiKaggle /></a>
          <a href="https://pingfence.vercel.app" >
            <img src={pingfence} alt="Pingfence Logo" className="pingfence-icon" />
          </a>
        </div>
    </div>




    <div className='items3'>
        <p>Previously Worked For</p>
        <div className='companylogos'>
          <div><img src={googlelogo} alt="linodeLogo" /></div>
          <div><img src={oraclelogo} alt="linodeLogo" /></div>
          <div><img src={linodeLogo} alt="linodeLogo" /></div>
        </div>
    </div>



    <div className='bigtitle1'>Skills</div>
     {/* First Row  */}
    <div className='skills-container'>
      <div><i className="devicon-python-plain colored" ></i></div>
      <div><i className='devicon-cplusplus-plain colored'></i></div>
      <div><i className='devicon-javascript-plain colored'></i></div>
      <div><i className='devicon-react-original colored'></i></div>
      <div><i className='devicon-java-plain colored'></i></div>
      <div><i className='devicon-linux-plain colored'></i></div>
      <div><i className='devicon-figma-plain colored'></i></div>
    </div>
     {/* Second Row  */}
    <div className='skills-container'>
      <div><i className='devicon-git-plain colored'></i></div>
      <div><i className='devicon-unrealengine-plain colored'></i></div>
      <div><i className='devicon-vuejs-plain colored'></i></div>
      <div><i className='devicon-dot-net-plain colored'></i></div>
      <div><i className='devicon-django-plain colored'></i></div>
      <div><i className='devicon-azure-plain colored'></i></div>
      <div><i className='devicon-csharp-plain colored'></i></div>
    </div>
    {/* Third Row  */}
    <div className='skills-container'>
      <div><i className='devicon-github-plain colored'></i></div>
      <div><i className='devicon-arduino-plain colored'></i></div>
      <div><i className='devicon-c-plain colored'></i></div>
      <div><i className='devicon-css3-plain colored'></i></div>
      <div><i className='devicon-html5-plain colored'></i></div>
      <div><i className='devicon-mongodb-plain colored'></i></div>
    </div>





    <div className='bigtitle2'>Work Experience</div>
    <div className='experience-container'>
      <div><img src={work1} alt="work1" /></div>
      <div><img src={work2} alt="work2" /></div>
      <div><img src={work3} alt="work3" /></div>
    </div>




    <div className='bigtitle2'>Certifications</div>
    <div className='certification-container'>
      <div className='badges'>
          <a href="https://elearning.securityblue.team/home/certificate/531208502" >
          <img src={badge2} alt="IBM Cyber Sec Analyst Prof" />
        </a>
        
        <a href="https://coursera.org/verify/KM3QGU6QE5NQ" >
          <img src={badge4} alt="EC-Council Certificate" />
        </a>
        <a href="https://www.cloudskillsboost.google/public_profiles/05b87178-cd36-4a2a-be25-c4a40361439b/badges/3433890" >
          <img src={badge5} alt="Coursera Certificate 1" />
        </a>
        <a href="https://coursera.org/verify/Z5UH29X77QG8" >
          <img src={badge6} alt="LinkedIn Learning Certificate" />
        </a>
        <a href="https://www.linkedin.com/learning/certificates/4f7e88391b65d53077b2d80a44b73713095a78f2484fa33730b553efa4567516?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BdikUpjdRQoOkGI0oiJMucA%3D%3D" >
          <img src={badge7} alt="Coursera Certificate 2" />
        </a>
        <a href="https://coursera.org/verify/SK2K33ZJGNHD" >
          <img src={badge8} alt="HackerRank Certificate 1" />
        </a>
        <a href="https://www.hackerrank.com/certificates/4ba89b588c4b" >
          <img src={badge9} alt="Coursera Share Certificate" />
        </a>
        <a href="https://coursera.org/share/73cb9d8acd4d74bbe6ebc99e7e9d0a0f" >
          <img src={badge10} alt="MIET Certificate 1" />
        </a>
        <a href="https://courses.mietjammu.skillsnetwork.site/certificates/5c23c00975eb443a86860ed47c540e51" >
          <img src={badge11} alt="MIET Certificate 2" />
        </a>
        <a href="https://courses.mietjammu.skillsnetwork.site/certificates/bf314b46403a4034958e8afdc18646ea" >
          <img src={badge12} alt="HackerRank Certificate 2" />
        </a>
        <a href="https://courses.mietjammu.skillsnetwork.site/certificates/21d78d6980ef44608a337c29f58a16e5" >
          <img src={badge13} alt="Coursera Certificate 3" />
        </a>
        <a href="https://coursera.org/verify/KM3QGU6QE5NQhttps://courses.mietjammu.skillsnetwork.site/certificates/f1e6c9d3ae9d4aaebf782a55e51d068f" >
          <img src={badge14} alt="Coursera Certificate 4" />
        </a>
        <a href="https://www.hackerrank.com/certificates/93d6e4bf94f4" >
          <img src={badge15} alt="Coursera Certificate 4" />
        </a>
        <a href="https://coursera.org/verif%20y/ZH76SAPPR35J" >
          <img src={badge16} alt="Coursera Certificate 4" />
        </a>
        <a href="https://codered.eccouncil.org/certificate/633b381c-6258-48a2-8fef-23dcba19892b" >
          <img src={badge17} alt="Coursera Certificate 4" />
        </a>
        <a href="https://drive.google.com/file/d/1R6hbt-ZDlkvzC2Ny3gjgoOhN1VmlugCQ/view?usp=sharing" >
          <img src={badge18} alt="Coursera Certificate 4" />
        </a>
        </div>
    </div>





    <div className='bigtitle2'>Github Stats</div>
    <div className='experience-container2'>
      <div><img src={gitstats5} alt="work1" /></div>
      <div><img src={gitstats3} alt="work1" /></div>
      <div><img src={gitstats2} alt="work1" /></div>
      <div className='gitstats-odd-image'><img src={gitstats4} alt="work1" /></div>
    </div>





    <div className='bigtitle2'>My Contribution to Computer Science</div>
    <div className='owners-designation'>AI Based IDF in Home Automation</div>
    <div className='experience-container2'>
      <div className='gitstats-odd-image2'><img src={mycontribution} alt="work1" /></div>
      
    </div>
    




    <div className='bigtitle2'>Avail</div>
    <div className='bigtitle4'>Services</div>
    <div style={{width: '40%',marginBottom:'-10vh', marginTop:'3vh'}}>
      <h4>
        @Pingfence
      </h4>
    </div>
    <div className='pingfence-banner'>
      <a href="https://pingfence.vercel.app" >
        <img src={pingfencebanner} alt="pingfencebanner" />
      </a>
    </div>
    <div className='pingfence-banner-text'>
      <h4>
        At PingFence, we believe every idea deserves to be seen. 
        We digitize visions, craft powerful digital identities, 
        and turn concepts into traction. Your idea, our mission 
        — let's show the world what you have to offer.
      </h4>
    </div>
    <div className='pingfence-visit-site'>
      <a style={{textDecoration: 'none'}} href='https://pingfence.vercel.app' className='visit-site'>
        <h4>
        Visit Site →
        </h4>
      </a>
    </div>




    <div className='bigtitle2'>Join our</div>
    <div className='bigtitle4'>Hackers Club</div>
    <div className='dawnofdedsec'>
      <a href="https://dawnofdedsec.vercel.app"><img src={dawnofdedsec} alt="Join club" /></a>
    </div>
    <div className='joindedsec'>
      <a href="https://dawnofdedsec.vercel.app" >
        <img src={joindedsec} alt="Join club" />
      </a>
    </div>
    <div className='joindedsec-text'>
      <h4 className='joindedsec-text'>
        Dedsec is a community of hackers, developers, and tech
         enthusiasts who are passionate about technology and 
         its potential to change the world. We believe in the
          power of collaboration and knowledge sharing to drive 
          innovation and create a better future for all.
      </h4>
    </div>
    <div className='dedsec-about'>
      <div><img src={dedsecteam} alt="Join club" /></div>
      
      <div className='dedsec-about-text'>
        <p>Developed by a Russian, run by an Indian — DedSec
           is more than just a name; it's a movement. In an
            era where misinformation spreads faster than truth 
            and digital manipulation shapes perception, DedSec 
            stands as a defiant force. Our mission is to bridge
             the widening gap between information and reality 
             by empowering people with raw, unfiltered data 
             and thought-provoking content. We challenge narratives,
              dismantle digital illusions, and expose the 
              layers of control that often go unseen. Through 
              innovation, courage, and a relentless pursuit of 
              truth, DedSec aims to awaken minds and ignite 
              change in a world that's growing increasingly 
              numb to deception. </p>
      </div>
    </div>
    <div className='dedsec-about-text2'>
      <h4>
        Follow us on social media to stay updated on the latest news, 
        events, and breakthroughs. Join the conversation and connect
         with a community that challenges the norm.
      </h4>
    </div>

  </div>
}

export default Home;
